import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBell } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Pressable, View } from 'react-native';
import { WindowInformation } from '../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import NotificationModal from './NotificationModal';
import { RootNavigation } from '../Routes';
import { centralAPI } from '../services/central-api';
import { useQuery } from '@tanstack/react-query';

export default function NotificationBell({ navigation }: { navigation: RootNavigation; }) {
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();
    const [hasNotifications, setHasNotifications] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const { data, refetch } = useQuery({
        queryKey: ['getOwnNotifications'],
        queryFn: async () => {
            const notifications = await centralAPI.getOwnNotifications();
            if (notifications.notifications.length > 0) {
                setHasNotifications(true);
            } else {
                setHasNotifications(false);
            }
            return notifications;
        },
        enabled: true,
        refetchIntervalInBackground: true,
        refetchInterval: 60000,
    });



    return <>
        <Pressable
            style={styles.container(windowInfo)}
            onPress={() => setIsModalVisible(true)}
        >
            <FontAwesomeIcon icon={faBell as IconDefinition}
                color={theme.colors.neutral['500']}
                style={styles.notificationIcon(windowInfo)}
            />
            {hasNotifications &&
                <View style={styles.notificationDot} />
            }
        </Pressable >

        <NotificationModal
            navigation={navigation}
            setIsModalVisible={setIsModalVisible}
            isModalVisible={isModalVisible}
            notifications={data?.notifications ?? []}
            refetch={refetch}
        />
    </>;
}

const stylesheet = createStyleSheet((theme) => ({
    container: (windowInfo: { isMobile: boolean; }) => ({
        marginRight: windowInfo.isMobile ? 16 : 0,
    }),
    notificationIcon: (windowInfo: { isMobile: boolean; }) => ({
        height: windowInfo.isMobile ? 26 : 20,
        width: windowInfo.isMobile ? 26 : 20,
    }),
    notificationDot: {
        position: 'absolute',
        right: 0,
        top: '9%',
        width: '45%',
        height: '45%',
        borderRadius: 50,
        backgroundColor: theme.colors.primary[500]
    }
}));
